import { object } from 'prop-types';
import React from 'react';

import { NamedLink } from '../../components';
import pickerCss from '../../components/PackagePicker/PackagePicker.module.css';
import { PACKAGE_PICKER_HASH } from '../../components/PackagePicker/PackagePicker';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { normalizePackages, packagePriceLabel, selectedPackage } from '../../util/listingPackages';
import { propTypes } from '../../util/types';
import { createSlug } from '../../util/urlHelpers';

import css from './CheckoutPage.module.css';

const CheckoutPackageRecap = ({ listing, intl, config }) => {
  const pkgs = normalizePackages(listing?.attributes?.publicData?.packages);
  const item = selectedPackage(pkgs?.items, listing?.id?.uuid);
  if (!item || !listing?.id?.uuid) {
    return null;
  }

  const slug = createSlug(listing.attributes?.title || '');
  const price = packagePriceLabel(listing, intl, config);

  return (
    <div className={css.packageRecap} data-testid="checkout-package-recap">
      <div className={css.packageRecapHeader}>
        <h2 className={css.packageRecapTitle}>
          <FormattedMessage id="CheckoutPage.chosenPackage" />
        </h2>
        <NamedLink
          name="ListingPage"
          params={{ id: listing.id.uuid, slug }}
          to={{ hash: `#${PACKAGE_PICKER_HASH}` }}
          className={css.packageRecapEdit}
        >
          <FormattedMessage id="CheckoutPage.editPackage" />
        </NamedLink>
      </div>
      <div className={`${pickerCss.row} ${pickerCss.rowSelected} ${pickerCss.rowCurrent}`}>
        <span className={pickerCss.copy}>
          <span className={pickerCss.name}>{item.name}</span>
          {item.description ? (
            <span className={pickerCss.description}>{item.description}</span>
          ) : null}
        </span>
        <span className={pickerCss.price}>{price}</span>
      </div>
    </div>
  );
};

CheckoutPackageRecap.propTypes = {
  listing: propTypes.listing,
  intl: intlShape.isRequired,
  config: object,
};

export default CheckoutPackageRecap;
